import React, {useCallback, useContext, useEffect, useState} from "react";
import {SidebarTab} from "../Sidebar";
import {Container, MainContent} from "./styles";
import SidebarCardHeader from "../SidebarCardHeader";
import SidebarCardFooter from "../SidebarCardFooter";
import {DataIdsContext} from "../../pages/Dashboard/Dashboard";
import {DataEsgIdsContext} from "../../pages/Esg/EsgDashboard";
import {getFintechWeakSignals} from "../../helper/functions";
import {DataFintechIdsContext} from "../../pages/Fintech/FintechDashboard";
import {ITypeRadar} from "../../types";
import SideBarContentFintech from "./SidebarCardContent/SideBarContentFintech";
import SideBarContentFintechWeakSignals from "./SidebarCardContent/SideBarContentFintechWeakSignals";
import {DataStateInitiativeIdsContext} from "../../pages/StateInitiative/StateInitiative";
import {DataStateInitiativeIdsContext as DataStateOrganisationsIdsContext} from "../../pages/StateInitiative/StateOrganisations";
import SideBarContentStateInitiative from "./SidebarCardContent/SideBarContentStateInitiative";
import SideBarContentStateOrganisations from "./SidebarCardContent/SideBarContentStateOrganisations";
import {SideBarContentEsg} from "./SidebarCardContent/SideBarContentEsg";
import {SideBarContentMap} from "./SidebarCardContent/SideBarContentMap";
import {
  IClusterDataFromServer,
  IClustersMolecule,
  IMoleculesDataFromServer,
  IProductsItem,
  ITechMolecules2FromServerWithProducts,
} from "../../pages/Dashboard/Dashboard.type";
import {
  apiKeyDataCRGCI,
  apiKeyDataFintech,
  apiKeyDataTehnology,
  urlApiDataFintech,
  urlApiDataTehnology,
} from "../../helper/api";
import {NavigationActions} from "../../types/NavigationBlocks";
import {
  shouldShowOrganisationSidebar,
  shouldShowInitiativeView,
  shouldShowWorkerView,
} from "../../utils/navigationBlockUtils";
import useFetchDataFintechById from "../../hooks/useFetchDataFintechById";
import useFetchDataTechDirectionById from "../../hooks/useFetchDataTechDirection";
import useFetchDataTechClusterById from "../../hooks/useFetchDataTechCluster";
import {SideBarContentMoleculeTwo} from "./SidebarCardContent/SideBarContentMoleculeTwo";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../config/featureFlags";
import {BATTERY_MATURITY_ORDER} from "../../helper/batteryMaturity";
import {
  CHART_VIEW_TITLES,
  ChartView,
  isActiveChartView,
} from "../../types/chartView";
import {
  IPeople,
  IPrevPeople,
  ICRGCIResponse,
} from "../../pages/StateInitiative/StateInitiative.type";

interface SidebarCardProps {
  isLogin?: boolean;
  role?: string | null;
  activeTab: SidebarTab;
  resetToDefaultTab: () => void;
  setActiveTab: (tab: SidebarTab) => void;
  cpuStep: number;
  setCpuStep: (step: number) => void;
  typeRadar: ITypeRadar;
  colorTitle?: string;
  idMoleculeActive?: number | string | null;
  initiativesData?: any;
  moleculesData?: IMoleculesDataFromServer;
  moleculesData2?: ITechMolecules2FromServerWithProducts[];
  isOpenSideBarStackHolders?: boolean;
  setIsOpenSideBarStackHolders?: (value: boolean) => void;
  activeWorker?: IPeople;
  setActiveWorker?: (value: IPeople) => void;
  idWorkerShowConnections?: string;
  setIdWorkerShowConnections?: (id: string) => void;
  prevIdWorker?: IPrevPeople[];
  setPrevIdWorker?: (PrevPeople: IPrevPeople[]) => void;
  currentSector?: string;
  documentId?: string;
  openOrganisationsRadar?: (initiativeTitle: string) => void;
  closeOrganisationsRadar?: () => void;
  backToOrganisationSidebar?: () => void;
  closeSidebarOrganisations?: () => void;
  activeWorkerOrg?: IPeople;
  setActiveWorkerOrg?: (value: IPeople | undefined) => void;
  onWorkerDataChange?: (workerData: any) => void;
  crgciData?: ICRGCIResponse | null;
  isFromOrganisationsPage?: boolean;

  navigationBlocks?: NavigationActions & {
    currentBlock: any;
    navigationStack: any[];
  };
}

const SidebarCard: React.FC<SidebarCardProps> = ({
  isLogin,
  role,
  activeTab,
  resetToDefaultTab,
  setActiveTab,
  cpuStep,
  setCpuStep,
  typeRadar,
  colorTitle,
  idMoleculeActive,
  moleculesData,
  moleculesData2,
  isOpenSideBarStackHolders,
  setIsOpenSideBarStackHolders,
  activeWorker,
  setActiveWorker,
  idWorkerShowConnections,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
  currentSector,
  documentId,
  openOrganisationsRadar,
  closeOrganisationsRadar,
  backToOrganisationSidebar,
  closeSidebarOrganisations,
  activeWorkerOrg: activeWorkerOrgProp,
  setActiveWorkerOrg: setActiveWorkerOrgProp,
  onWorkerDataChange,
  crgciData,
  isFromOrganisationsPage = false,
  navigationBlocks,
}) => {
  const context = useContext(DataIdsContext) || {};
  const contextEsg = useContext(DataEsgIdsContext) || {};
  const contextFintech = useContext(DataFintechIdsContext) || {};
  const contextStateInitiative =
    useContext(DataStateInitiativeIdsContext) || {};
  const contextStateOrganisations =
    useContext(DataStateOrganisationsIdsContext) || {};

  const [chartView, setChartView] = useState<ChartView>("none");
  const getContextRadar = () => {
    if (
      typeRadar === "map" ||
      typeRadar === "molecula" ||
      typeRadar === "moleculeTwo"
    )
      return context;
    if (typeRadar === "esg") return contextEsg;
    if (typeRadar === "fintech" || typeRadar === "weak_signals")
      return contextFintech;
    if (typeRadar === "stateInitiative") {
      if (activeTab === SidebarTab.StateOrganisations) {
        return contextStateOrganisations;
      }
      return contextStateInitiative;
    }
  };
  const contextData = getContextRadar() || {};
  const {dataIds, setDataIds} = contextData;

  const [moleculeTwoDataActive, setMoleculeTwoDataActive] =
    useState<IProductsItem | null>(null);

  useEffect(() => {
    if (moleculesData2 && dataIds) {
      const dataProductMoleculeFind: ITechMolecules2FromServerWithProducts | null =
        moleculesData2?.find((item) => item.id === dataIds.directionId) ?? null;

      const moleculeTwoDataActiveFind: IProductsItem | null =
        dataProductMoleculeFind?.products.find(
          (item) => item.id === dataIds.clusterId
        ) ?? null;
      setMoleculeTwoDataActive(moleculeTwoDataActiveFind);
    }
  }, [dataIds, moleculesData2]);

  if (!apiKeyDataCRGCI) {
    throw new Error("CRGCI API key не тот");
  }

  const apiUrlFintech = `${urlApiDataFintech}/api/trends`;
  if (!apiKeyDataFintech) {
    throw new Error("API Fintech key не тот");
  }

  const apiUrlTechDirection = `${urlApiDataTehnology}/api/directions`;
  const apiUrlTechCluster = `${urlApiDataTehnology}/api/clusters`;
  // const apiUrlTechTehnologie = `${urlApiDataTehnology}/api`;
  // const apiUrlTechTehnologie = `${urlApiDataTehnology}/api/tehnologies`;
  if (!apiKeyDataTehnology) {
    throw new Error("API key Карта технологий не тот");
  }

  const {directionData: directionDataByIdFromServer} =
    useFetchDataTechDirectionById(
      apiUrlTechDirection,
      apiKeyDataTehnology,
      typeRadar === "stateInitiative" ? null : dataIds?.directionId || null
    );

  const {clusterData: clusterDataByIdFromServer} = useFetchDataTechClusterById(
    apiUrlTechCluster,
    apiKeyDataTehnology,
    dataIds?.clusterId || null
  );

  // const {tehnologieData: tehnologyDataByIdFromServer} =
  //   useFetchDataTechTehnologyById(
  //     apiUrlTechTehnologie,
  //     apiKeyDataTehnology,
  //     dataIds.tehnologyId
  //   );

  // const {tehnologieData: tehnologieDataByIdFromServer} =
  //   useFetchDataTechTehnologyById(
  //     apiUrlTechTehnologie,
  //     apiKeyDataTehnology,
  //     dataIds.clusterId
  //   );

  const {initiativeData: fetchDataFintech} = useFetchDataFintechById(
    apiUrlFintech,
    apiKeyDataFintech,
    typeRadar === "stateInitiative" ? null : dataIds?.trendId || null
  );

  const [data, setData] = useState<any>();
  const [sortOption, setSortOption] = useState<string | null>(null);
  const [selectedInitiative, setSelectedInitiative] = useState<string | null>(
    null
  );
  const [forceShowOrganisations, setForceShowOrganisations] = useState(false);

  // Используем проп если передан, иначе локальный стейт
  const [localActiveWorkerOrg, setLocalActiveWorkerOrg] = useState<
    IPeople | undefined
  >(undefined);
  const activeWorkerOrg =
    activeWorkerOrgProp !== undefined
      ? activeWorkerOrgProp
      : localActiveWorkerOrg;
  const setActiveWorkerOrg = setActiveWorkerOrgProp || setLocalActiveWorkerOrg;

  const [clusterData, setClusterData] = useState<
    IClusterDataFromServer | undefined
  >();
  const [technologyData, setTechnologyData] = useState<any>();
  const [technologieId, setTechnologieId] = useState<number | string | null>(
    dataIds?.tehnologyId || null
  );
  const [dataCurrentMolecula, setDataCurrentMolecula] = useState<
    IClustersMolecule | undefined
  >(undefined);

  useEffect(() => {
    setChartView("none");
  }, [
    dataIds?.directionId,
    dataIds?.clusterId,
    dataIds?.tehnologyId,
    activeTab,
    cpuStep,
  ]);

  useEffect(() => {
    if (dataIds) {
      setTechnologieId(dataIds.tehnologyId);
    }
  }, [dataIds]);

  useEffect(() => {
    setSortOption(null);
  }, [dataIds]);

  // If cluster Battery is disabled, ensure we never keep an invalid cluster sort state.
  useEffect(() => {
    if (
      !FEATURE_CLUSTER_BATTERY_METRIC_ENABLED &&
      activeTab === SidebarTab.Clusters &&
      sortOption === "battery_russia"
    ) {
      setSortOption(null);
    }
  }, [activeTab, sortOption]);

  const fetchData = useCallback(async () => {
    if (!dataIds) return;

    if (
      typeRadar === "map" ||
      typeRadar === "molecula" ||
      typeRadar === "moleculeTwo"
    ) {
      try {
        if (
          activeTab === SidebarTab.Clusters &&
          dataIds &&
          dataIds.directionId !== undefined
        ) {
          const directionData = directionDataByIdFromServer?.data;

          if (dataCurrentMolecula) {
            const filteredDirections = directionData;
            // );

            setData({
              ...directionData,
              clusters: filteredDirections,
            });
          } else {
            setData(directionData);
          }
        } else if (
          activeTab === SidebarTab.CPU &&
          dataIds &&
          dataIds.clusterId !== undefined
        ) {
          const clusterData = clusterDataByIdFromServer?.data;

          if (dataCurrentMolecula) {
            const allTehnologiesIds = dataCurrentMolecula.data.map(
              (cluster) => cluster.technologies
            );
            const filteredTechnologies = clusterData?.technologies.filter(
              (technologie: any) => allTehnologiesIds.includes(technologie.id)
            );

            setClusterData({
              ...clusterData,
              technologies: filteredTechnologies ?? [],
            } as IClusterDataFromServer);
          } else {
            if (idMoleculeActive) {
              const arrFindTechnologiesFromMoleculeCurrent =
                moleculesData?.clusters?.find(
                  (cluster) =>
                    cluster?.cluster?.documentId === clusterData?.documentId
                )?.technologies;
              setClusterData({
                ...clusterData,
                technologies:
                  clusterData?.technologies.filter((item) =>
                    arrFindTechnologiesFromMoleculeCurrent?.some(
                      (tech) => tech.technology.documentId === item.documentId
                    )
                  ) ?? [],
              } as IClusterDataFromServer);
            } else {
              setClusterData(clusterData);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else if (typeRadar === "esg") {
      try {
        // const directionData = await getEsgProjectData(dataIds.projectId);
        // setTechnologyData(directionData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else if (typeRadar === "fintech" || typeRadar === "weak_signals") {
      if (typeRadar === "fintech") {
        setTechnologyData(fetchDataFintech?.data);
      } else {
        try {
          const directionData = await getFintechWeakSignals(dataIds?.trendId);
          setTechnologyData(directionData);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }
  }, [
    dataIds,
    activeTab,
    dataCurrentMolecula,
    typeRadar,
    fetchDataFintech,
    directionDataByIdFromServer,
    clusterDataByIdFromServer,
    idMoleculeActive,
    moleculesData?.clusters,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSort = (option: string) => {
    if (sortOption === option) {
      return;
    }
    if (
      !FEATURE_CLUSTER_BATTERY_METRIC_ENABLED &&
      activeTab === SidebarTab.Clusters &&
      option === "battery_russia"
    ) {
      return;
    }
    setSortOption(option);

    if (activeTab === SidebarTab.Clusters && data?.clusters) {
      const sortedClusters = [...data.clusters].sort((a, b) => {
        if (option === "investVolume") return b.invest_volume - a.invest_volume;
        if (option === "marketVolume") return b.market_volume - a.market_volume;
        if (option === "critical")
          return (b.critical ? 1 : 0) - (a.critical ? 1 : 0);
        if (option === "growth_potential")
          return (b.growth_potential ? 1 : 0) - (a.growth_potential ? 1 : 0);
        if (option === "national")
          return (b.national ? 1 : 0) - (a.national ? 1 : 0);
        if (option === "gpb") return (b.gpb ? 1 : 0) - (a.gpb ? 1 : 0);
        if (option === "battery_russia") {
          const aValue = BATTERY_MATURITY_ORDER[a.battery_russia] || 0;
          const bValue = BATTERY_MATURITY_ORDER[b.battery_russia] || 0;
          return bValue - aValue;
        }
        return 0;
      });
      setData({...data, clusters: sortedClusters});
    } else if (activeTab === SidebarTab.CPU && clusterData) {
      const sortedTechnologies = [...clusterData.technologies].sort((a, b) => {
        if (option === "investVolume")
          return b.invest_volume_tier - a.invest_volume_tier;
        if (option === "potentialVolume")
          return (
            (b.potential_volume_tier || 0) - (a.potential_volume_tier || 0)
          );
        if (option === "trl") return (b.trl_tier || 0) - (a.trl_tier || 0);
        if (option === "growth_potential")
          return (b.growth_potential ? 1 : 0) - (a.growth_potential ? 1 : 0);
        if (option === "gpb") return (b.gpb ? 1 : 0) - (a.gpb ? 1 : 0);
        if (option === "battery_russia") {
          const aValue = BATTERY_MATURITY_ORDER[a.battery_russia] || 0;
          const bValue = BATTERY_MATURITY_ORDER[b.battery_russia] || 0;
          return bValue - aValue;
        }
        return 0;
      });
      setClusterData({...clusterData, technologies: sortedTechnologies});
    }
  };

  const color = "#CE93D8";

  const handleClose = () => {
    resetToDefaultTab();
    if (setActiveWorker) setActiveWorker({} as IPeople);
    setActiveWorkerOrg(undefined);
  };

  const getTechnologyData = async (id: number) => {
    try {
      // const response = await fetchTechnologyData(id);
      // setTechnologyData(tehnologieDataByIdFromServer?.data);
    } catch (err) {
      console.error(err, "Error while fetching direction data");
    }
  };

  const handleCardClick = (id: number | string, name: string) => {
    if (!dataIds) return;
    setDataIds({
      directionId: dataIds.directionId,
      clusterId: id,
      directionName: dataIds.directionName,
      clusterName: name,
      colorTitle: dataIds.colorTitle || "#3290B7",
    });
    setActiveTab(SidebarTab.CPU);
    setCpuStep(1);
  };
  const handleSecondStepCpu = (id: string) => {
    setActiveTab(SidebarTab.CPU);
    // getTechnologyData(id);
    setTechnologieId(id);
    setCpuStep(2);
  };

  useEffect(() => {
    if (dataIds?.tehnologyId && cpuStep === 2) {
      getTechnologyData(dataIds?.tehnologyId);
    }
  }, [dataIds?.tehnologyId, cpuStep]);

  const handleInitiativeClick = (documentId: string) => {
    setSelectedInitiative(documentId);
    setForceShowOrganisations(false);
    if (openOrganisationsRadar) {
      openOrganisationsRadar(documentId);
    }
  };

  const handleBackFromInitiative = () => {
    setSelectedInitiative(null);

    if (closeOrganisationsRadar) {
      closeOrganisationsRadar();
    }
  };

  const handleBackClick = () => {
    // Сначала проверяем block-based навигацию
    if (navigationBlocks && navigationBlocks.canGoBack()) {
      if (backToOrganisationSidebar) {
        backToOrganisationSidebar();
        return;
      }
    }

    // Fallback на старую логику для совместимости
    if (activeWorkerOrg) {
      setActiveWorkerOrg(undefined);
      return;
    }

    if (selectedInitiative) {
      if (activeTab === SidebarTab.StateInitiative && isFromOrganisationsPage) {
      } else {
        handleBackFromInitiative();
        return;
      }
    }

    if (activeTab === SidebarTab.StateInitiative && isFromOrganisationsPage) {
      if (navigationBlocks) {
        setSelectedInitiative(null);
        setForceShowOrganisations(false);
      }

      if (backToOrganisationSidebar) {
        backToOrganisationSidebar();
      } else if (closeOrganisationsRadar) {
        closeOrganisationsRadar();
      }
      return;
    }
    if (activeChartView !== "none") {
      setChartView("none");
      return;
    }
    if (isOpenSideBarStackHolders && setIsOpenSideBarStackHolders) {
      setIsOpenSideBarStackHolders(false);
      return;
    }
    if (activeTab === SidebarTab.StateOrganisations) {
      if (closeSidebarOrganisations) {
        closeSidebarOrganisations();
      } else {
        handleClose();
      }
      return;
    }
    if (activeTab === SidebarTab.CPU && cpuStep === 1) {
      if (!dataIds) return;
      setActiveTab(SidebarTab.Clusters);
      setDataIds({
        directionId: dataIds.directionId,
        clusterId: null,
        directionName: dataIds.directionName,
        clusterName: "",
        colorTitle: dataIds.colorTitle || "#3290B7",
      });
      return;
    }
    setCpuStep(1);
  };

  const handlePreviewTitle = () => {
    if (activeTab === SidebarTab.Projects) {
      return dataIds.directionName;
    }
    if (activeTab === SidebarTab.Clusters) {
      return "Технологическое направление";
    }
    if (activeTab === SidebarTab.CPU && cpuStep === 1) {
      return dataIds.directionName;
    }
    if (activeTab === SidebarTab.CPU && cpuStep === 2) {
      return dataIds.clusterName;
    }
    if (activeTab === SidebarTab.Esg) {
      return dataIds.directionName;
    }
    if (activeTab === SidebarTab.WeakSignal) {
      return technologyData?.segment;
    }
    if (activeTab === SidebarTab.Trends) {
      return dataIds?.directionName;
    }
    if (activeTab === SidebarTab.StateInitiative) {
      return dataIds?.directionName;
    }
    if (activeTab === SidebarTab.StateOrganisations) {
      const title = dataIds?.currentSector || currentSector || "Сектор";

      return title;
    }
    return null;
  };

  const handleSortTitle = () => {
    if (activeTab === SidebarTab.Clusters) {
      return `ТЕХНОЛОГИЧЕСКИЕ КЛАСТЕРЫ (${data?.clusters.length})`;
    }
    if (cpuStep === 2) {
    } else {
      return `ТЕХНОЛОГИИ (${clusterData?.technologies.length})`;
    }
  };

  const activeChartView = isActiveChartView(chartView, activeTab, cpuStep)
    ? chartView
    : "none";

  return (
    <>
      <Container
        style={
          isOpenSideBarStackHolders || typeRadar === "stateInitiative"
            ? {width: 500}
            : {}
        }
      >
        <SidebarCardHeader
          previewTitle={(() => {
            const title =
              activeChartView !== "none"
                ? CHART_VIEW_TITLES[activeChartView]
                : isOpenSideBarStackHolders
                ? "Цифровой профиль физического лица"
                : handlePreviewTitle();

            return title;
          })()}
          colorTitle={dataIds?.colorTitle || "#3290B7"}
          lastUpdateInfo={
            technologyData?.updated_date && technologyData.updated_date
          }
          onClose={() => {
            setSortOption(null);
            // Для StateOrganisations без истории навигации закрываем сайдбар полностью
            if (
              activeTab === SidebarTab.StateOrganisations &&
              !navigationBlocks?.canGoBack() &&
              closeSidebarOrganisations
            ) {
              closeSidebarOrganisations();
            } else {
              handleClose();
            }
          }}
          isShowClose={
            activeChartView !== "none"
              ? false
              : isOpenSideBarStackHolders
              ? false
              : activeTab === SidebarTab.StateOrganisations
              ? !navigationBlocks?.canGoBack() // Показываем крестик только если нет истории навигации
              : activeTab === SidebarTab.StateInitiative &&
                isFromOrganisationsPage
              ? false
              : true
          }
          color={color}
          isBackAvailable={
            activeChartView !== "none"
              ? true
              : isOpenSideBarStackHolders
              ? true
              : activeTab === SidebarTab.StateOrganisations
              ? navigationBlocks?.canGoBack() // Показываем стрелочку только если есть история навигации
              : activeTab === SidebarTab.StateInitiative &&
                isFromOrganisationsPage
              ? true
              : activeTab !== SidebarTab.Clusters &&
                activeTab !== SidebarTab.Projects &&
                activeTab !== SidebarTab.StateInitiative &&
                activeTab !== SidebarTab.Trends &&
                activeTab !== SidebarTab.WeakSignal
          }
          onBackApply={handleBackClick}
        />
        <MainContent>
          {typeRadar === "map" || typeRadar === "molecula" ? (
            <SideBarContentMap
              dataDirection={data}
              typeRadar={typeRadar}
              activeTab={activeTab}
              dataCluster={clusterData}
              titleCluster={dataIds.clusterName}
              cpuStep={cpuStep}
              // dataTechnology={tehnologyDataByIdFromServer?.data}
              handleCardClick={handleCardClick}
              handleSecondStepCpu={handleSecondStepCpu}
              sortOption={sortOption}
              handleSortTitle={handleSortTitle}
              handleSort={handleSort}
              // dataCurrentMolecula={dataCurrentMolecula}
              colorTitle={dataIds?.colorTitle}
              technologieId={technologieId}
              idMoleculeActive={idMoleculeActive as number}
              clusterIdOnTehnologie={dataIds?.clusterIdNumber}
              setChartView={setChartView}
              chartView={activeChartView}
            />
          ) : typeRadar === "moleculeTwo" ? (
            <SideBarContentMoleculeTwo
              idMoleculeActive={idMoleculeActive as number}
              data={moleculeTwoDataActive}
              activeTab={activeTab}
              typeRadar={typeRadar}
              dataCurrentMolecula={dataCurrentMolecula}
              colorTitle={dataIds?.colorTitle || "#3290B7"}
              technologieId={technologieId}
              setChartView={setChartView}
              chartView={activeChartView}
            />
          ) : typeRadar === "esg" ? (
            <SideBarContentEsg
              typeRadar={typeRadar}
              colorTitle={dataIds?.colorTitle || "#3290B7"}
              projectId={dataIds?.projectId}
            />
          ) : typeRadar === "weak_signals" ? (
            <SideBarContentFintechWeakSignals
              data={technologyData}
              typeRadar={typeRadar}
              colorTitle={colorTitle}
            />
          ) : typeRadar === "fintech" ? (
            <SideBarContentFintech
              data={technologyData}
              typeRadar={typeRadar}
              colorTitle={colorTitle}
            />
          ) : activeTab === SidebarTab.StateOrganisations ? (
            (() => {
              const currentBlock = navigationBlocks?.currentBlock;

              if (currentBlock) {
                if (shouldShowInitiativeView(currentBlock)) {
                  return (
                    <SideBarContentStateInitiative
                      isLogin={isLogin}
                      role={role}
                      documentId={
                        currentBlock.data?.initiativeId || selectedInitiative
                      }
                      typeRadar={typeRadar}
                      colorTitle={dataIds?.colorTitle || "#3290B7"}
                      isOpenSideBarStackHolders={isOpenSideBarStackHolders}
                      setIsOpenSideBarStackHolders={
                        setIsOpenSideBarStackHolders
                      }
                      activeWorker={activeWorker}
                      setActiveWorker={setActiveWorker}
                      idWorkerShowConnections={idWorkerShowConnections}
                      setIdWorkerShowConnections={setIdWorkerShowConnections}
                      prevIdWorker={prevIdWorker}
                      setPrevIdWorker={setPrevIdWorker}
                      crgciData={crgciData}
                    />
                  );
                } else if (shouldShowOrganisationSidebar(currentBlock)) {
                  return (
                    <SideBarContentStateOrganisations
                      data={dataIds?.organizationData}
                      typeRadar={typeRadar}
                      colorTitle={dataIds?.colorTitle || "#3290B7"}
                      onInitiativeClick={handleInitiativeClick}
                      activeWorker={activeWorkerOrg}
                      setActiveWorker={setActiveWorkerOrg}
                      onWorkerDataChange={onWorkerDataChange}
                      setIdWorkerShowConnections={setIdWorkerShowConnections}
                    />
                  );
                } else if (shouldShowWorkerView(currentBlock)) {
                  return (
                    <SideBarContentStateInitiative
                      isLogin={isLogin}
                      role={role}
                      documentId={
                        currentBlock.data?.initiativeId || selectedInitiative
                      }
                      typeRadar={typeRadar}
                      colorTitle={dataIds?.colorTitle || "#3290B7"}
                      isOpenSideBarStackHolders={isOpenSideBarStackHolders}
                      setIsOpenSideBarStackHolders={
                        setIsOpenSideBarStackHolders
                      }
                      activeWorker={activeWorker}
                      setActiveWorker={setActiveWorker}
                      idWorkerShowConnections={idWorkerShowConnections}
                      setIdWorkerShowConnections={setIdWorkerShowConnections}
                      prevIdWorker={prevIdWorker}
                      setPrevIdWorker={setPrevIdWorker}
                      crgciData={crgciData}
                    />
                  );
                } else if (shouldShowOrganisationSidebar(currentBlock)) {
                  return (
                    <SideBarContentStateOrganisations
                      data={dataIds?.organizationData}
                      typeRadar={typeRadar}
                      colorTitle={dataIds?.colorTitle || "#3290B7"}
                      onInitiativeClick={handleInitiativeClick}
                      activeWorker={activeWorkerOrg}
                      setActiveWorker={setActiveWorkerOrg}
                      onWorkerDataChange={onWorkerDataChange}
                      setIdWorkerShowConnections={setIdWorkerShowConnections}
                    />
                  );
                } else if (shouldShowWorkerView(currentBlock)) {
                  return (
                    <SideBarContentStateInitiative
                      isLogin={isLogin}
                      role={role}
                      documentId={
                        currentBlock.data?.initiativeId || selectedInitiative
                      }
                      typeRadar={typeRadar}
                      colorTitle={dataIds?.colorTitle || "#3290B7"}
                      isOpenSideBarStackHolders={isOpenSideBarStackHolders}
                      setIsOpenSideBarStackHolders={
                        setIsOpenSideBarStackHolders
                      }
                      activeWorker={currentBlock.data?.workerData}
                      setActiveWorker={setActiveWorker}
                      idWorkerShowConnections={currentBlock.data?.workerId}
                      setIdWorkerShowConnections={setIdWorkerShowConnections}
                      prevIdWorker={prevIdWorker}
                      setPrevIdWorker={setPrevIdWorker}
                      crgciData={crgciData}
                    />
                  );
                }
              }
              if (selectedInitiative && !forceShowOrganisations) {
                return (
                  <SideBarContentStateInitiative
                    isLogin={isLogin}
                    role={role}
                    documentId={selectedInitiative}
                    typeRadar={typeRadar}
                    colorTitle={dataIds?.colorTitle || "#3290B7"}
                    isOpenSideBarStackHolders={isOpenSideBarStackHolders}
                    setIsOpenSideBarStackHolders={setIsOpenSideBarStackHolders}
                    activeWorker={activeWorker}
                    setActiveWorker={setActiveWorker}
                    idWorkerShowConnections={idWorkerShowConnections}
                    setIdWorkerShowConnections={setIdWorkerShowConnections}
                    prevIdWorker={prevIdWorker}
                    setPrevIdWorker={setPrevIdWorker}
                    crgciData={crgciData}
                  />
                );
              } else {
                return (
                  <SideBarContentStateOrganisations
                    data={dataIds?.organizationData}
                    typeRadar={typeRadar}
                    colorTitle={dataIds?.colorTitle || "#3290B7"}
                    onInitiativeClick={handleInitiativeClick}
                    activeWorker={activeWorkerOrg}
                    setActiveWorker={setActiveWorkerOrg}
                    onWorkerDataChange={onWorkerDataChange}
                    setIdWorkerShowConnections={setIdWorkerShowConnections}
                  />
                );
              }
            })()
          ) : (
            <SideBarContentStateInitiative
              isLogin={isLogin}
              role={role}
              documentId={documentId || dataIds?.trendId}
              typeRadar={typeRadar}
              colorTitle={dataIds?.colorTitle || "#3290B7"}
              isOpenSideBarStackHolders={isOpenSideBarStackHolders}
              setIsOpenSideBarStackHolders={setIsOpenSideBarStackHolders}
              activeWorker={activeWorker}
              setActiveWorker={setActiveWorker}
              idWorkerShowConnections={idWorkerShowConnections}
              setIdWorkerShowConnections={setIdWorkerShowConnections}
              prevIdWorker={prevIdWorker}
              setPrevIdWorker={setPrevIdWorker}
              crgciData={crgciData}
            />
          )}
        </MainContent>
        <SidebarCardFooter activeTab={activeTab} />
      </Container>
    </>
  );
};
export default React.memo(SidebarCard);
